import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TextField,
  NumberField,
  Paragraph,
  Dropdown,
  DateTime,
  Checkbox,
  Toggle,
  RadioButton,
  Link,
} from "./CustomizedControls";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteBookingFile,
  getActivityAssignmentIdByBookingId,
  getValueByBookingTemplateId,
  updateBooking,
  uploadBookingFile,
} from "../../redux/actions/booking";
import { getAllCustomFieldsByBookingTemplateId } from "../../redux/actions/bookingtemplate";
import { getCollaboratorByType } from "../../redux/actions/user";
import { Customer } from "../../constant/AuthenticationConstant";
import Select from "react-select";
import Loader from "./Loader";
import { sanitizeInput } from "../../utils";

function UpdateBooking() {
  const [component, setComponent] = useState([]);
  const [customFieldMaxRowSize, setCustomFieldMaxRowSize] = useState();
  const [newjson, setNewJson] = useState([]);
  const [assignmentid, setAssignmentId] = useState("");
  const [updatedjson, setUpdatedJson] = useState([]);
  const [validateobj, setValidateObj] = useState([]);
  const [bookingtemplateid, setBookingTemplateId] = useState("");
  const [validation, setValidation] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { activity_assignment_id } = state;
  const dispatch = useDispatch();
  const [allcustomers, setAllCustomers] = useState([]);
  const [customer, setCustomer] = useState();
  const [customerId, setCustomerId] = useState("");
  const { collaboratorList } = useSelector((state) => state.user);
  const { bookingValue } = useSelector((state) => state.booking);
  const [uploadedfile, setUploadedFile] = useState([]);
  const [loaderOpen, setLoaderOpen] = useState(false);

  useEffect(() => {
    if (bookingValue) {
      setUploadedFile(bookingValue?.file_uploads);
    }
  }, [bookingValue]);

  useEffect(() => {
    if (
      component.length > 0 &&
      newjson.length > 0 &&
      component.length !== newjson.length
    ) {
      var arr = [];
      component.map((ele) => {
        const type = ele.component.type;
        arr.push({
          booking_template_custom_field_id:
            ele.booking_template_custom_field_id,
          value:
            type === "toggle" || type === "check box"
              ? JSON.stringify(ele.component.is_check_by_default)
              : null,
          type: type,
          booking_template_custom_field: ele,
          booking_id: activity_assignment_id,
        });
      });
      if (newjson.length > 0) {
        for (let i = 0; i < newjson.length; i++) {
          for (let j = 0; j < arr.length; j++) {
            if (
              newjson[i].booking_template_custom_field?.component_id ==
              arr[j].booking_template_custom_field?.component_id
            ) {
              arr[j].value = newjson[i].value;
              arr[j].booking_control_id = newjson[i].booking_control_id;
            }
          }
        }
      }
      setUpdatedJson(arr);
    } else {
      setUpdatedJson(newjson);
    }
  }, [component, newjson]);

  useEffect(() => {
    dispatch(
      getActivityAssignmentIdByBookingId(activity_assignment_id, (res) => {
        if (res.status === 1) {
          setAssignmentId(res.data[0].activity_assignment_id);
          setBookingTemplateId(res.data[0].booking_template_id);
          setCustomerId(res.data[0].customer_id);
          if (res.data[0].customer) {
            setCustomer({
              label: res.data[0].customer.name,
              value: res.data[0].customer.customer_id,
            });
          }
        }
      })
    );
    setNewJson([]);
    dispatch(
      getValueByBookingTemplateId(activity_assignment_id, (res) => {
        if (res.status === 1) {
          setNewJson(res.data.controls);
        }
      })
    );
    dispatch(getCollaboratorByType(Customer));
  }, []);

  useEffect(() => {
    if (collaboratorList?.data?.length > 0) {
      const arr = [];
      collaboratorList?.data?.map((item) => {
        arr.push({
          value: item.collaborator_id,
          label: item.name,
        });
      });
      setAllCustomers(arr);
    }
  }, [collaboratorList]);
  const getCustomerId = (e) => {
    setCustomer(e);
  };

  useEffect(() => {
    if (bookingtemplateid !== "") {
      dispatch(
        getAllCustomFieldsByBookingTemplateId(bookingtemplateid, (res) => {
          if (res.status === 1) {
            const seq = res.data.sort(function (a, b) {
              return a.sequence - b.sequence;
            });
            setComponent(seq);
          }
        })
      );
    }
  }, [bookingtemplateid]);

  const sortingFunction = (a, b) => {
    return (
      a.booking_template_custom_field.sequence -
      b.booking_template_custom_field.sequence
    );
  };

  const UpdateBooking = () => {
    const errorArray = updatedjson
      .sort(sortingFunction)
      .map((component, index) => {
        return component.booking_template_custom_field.is_required &&
          !component.value
          ? component.booking_template_custom_field_id
          : null;
      });

    setValidation(errorArray);
    if (errorArray.some((element) => typeof element === "string")) return;

    dispatch(
      updateBooking(updatedjson, assignmentid, customerId, customer, (res) => {
        if (res.status === 1) {
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content="Booking has been updated successfully."
                onClick={() => {
                  if (uploadedfile.length > 0) {
                    let formdata = new FormData();
                    for (const item of uploadedfile) {
                      formdata.append("file", item);
                    }
                    dispatch(
                      uploadBookingFile(
                        activity_assignment_id,
                        formdata,
                        (res) => {}
                      )
                    );
                  }
                  navigate(`/assignment/assign/${assignmentid}`);
                }}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };

  const handleChange = (e, id, type) => {
    if (type === "dropdown") {
      var value = e === null ? null : e.value;
    } else if (type === "checkbox") {
      var value = JSON.stringify(e.target.checked);
    } else {
      var value = type === "datetime" ? e[0] : sanitizeInput(e.target.value);
    }
    updatedjson.map((ele, index) => {
      if (ele.booking_template_custom_field_id === id) {
        let copyjson = [...updatedjson];
        copyjson[index].value = value;
        setUpdatedJson(copyjson);
      }
    });
  };

  const renderInput = (input, index, validation) => {
    var value;
    updatedjson.forEach((ele) => {
      if (
        ele.booking_template_custom_field_id ===
        input.booking_template_custom_field_id
      ) {
        value = ele.value;
      }
    });
    const isMandatory = input.is_required;

    const gridPosition = JSON.parse(input.grid_position);
    const inputWidth = gridPosition?.w ? gridPosition.w : 2;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;

    const props = {
      isMandatory,
      validation,
      value,
      input,
      index,
      handleChange: handleChange,
      gridWidthClass,
    };
    if (input.component?.type === "text") {
      return <TextField {...props} />;
    } else if (input.component?.type === "toggle") {
      return <Toggle {...props} />;
    } else if (input.component?.type === "radio group") {
      return <RadioButton {...props} />;
    } else if (input.component?.type === "link") {
      return <Link {...props} />;
    } else if (input.component?.type === "check box") {
      return <Checkbox {...props} />;
    } else if (input.component?.type === "dropdown") {
      return <Dropdown {...props} />;
    } else if (input.component?.type === "date/time") {
      return <DateTime {...props} />;
    } else if (input.component?.type === "paragraph") {
      return <Paragraph {...props} />;
    } else if (input.component?.type === "number") {
      return <NumberField {...props} />;
    } else {
      return null;
    }
  };

  const uploadFile = (e) => {
    setLoaderOpen(true);
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      const maxFileSize = 4 * 1024 * 1024;
      if (item.size > maxFileSize) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file exceeds upload limit of 4 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (!type.includes(filetype.toLowerCase())) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
    }
    setUploadedFile((prev) => {
      return [...prev, ...e];
    });
    setLoaderOpen(false);
  };

  useEffect(() => {
    if (component.length > 0) {
      const lastCustomField = JSON.parse(
        component[component.length - 1].grid_position
      );
      const highestRow = lastCustomField.y;
      setCustomFieldMaxRowSize(highestRow);
    }
  }, [component]);

  return (
    <div class="block w-full sm:block h-full">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          UpdateBooking();
        }}
        className="overflow-y-auto flex-auto h-full"
      >
        <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 sm:inline-block p-[4px] rounded transition-all">
          <label for="customer" className="text-sm font-medium mb-1">
            Customer
          </label>
          <br />
          <Select
            className="basic-single text-sm unresetText"
            classNames={{
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            isClearable={true}
            isDisabled={customerId}
            classNamePrefix="select"
            name="customername"
            options={allcustomers}
            value={customer}
            placeholder="Select Customer"
            onChange={(e) => getCustomerId(e)}
          />
        </div>
        <br />
      
        {customFieldMaxRowSize?.toString() && component.length > 0 && (
          <div>
            {component.map((customeComponent, index) => {
              const filteredComponentList = component.filter(
                (element) => JSON.parse(element.grid_position).y === index
              );

              if (index <= customFieldMaxRowSize) {
                return (
                  <div className="flex flex-wrap">
                    {filteredComponentList.map((comp, indexNumber) => {
                      return renderInput(comp, comp.booking_template_custom_field_id, validation);
                    })}
                  </div>
                );
              }
            })}
          </div>
        )}

        <div className="w-full sm:w-full my-3 bg-white rounded-md">
          <div className="w-1/2 px-1">
            <h4 className="text-md font-medium leading-4 tracking-tight text-[#535860]">
              Document Upload
            </h4>
            <div
              className="h-[35px] text-sm bg-white rounded-md flex items-center justify-between cursor-pointer"
              type="button"
              onClick={(e) => {
                document.getElementById("updateBookingFile").click();
                document.getElementById("updateBookingFile").value = null;
              }}
            >
              Select file to upload
              <p
                className={`text-sm leading-3 font-semibold tracking-tight text-[--bg-color-500]`}
              >
                Select
              </p>
            </div>
            <div>
              {uploadedfile?.map((ele, index) => {
                return (
                  <div
                    className="h-[35px] bg-white rounded-md flex items-center justify-between cursor-pointer"
                    type="button"
                    onClick={(e) => {
                      const regexExp =
                        /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
                      const isUuid = regexExp.test(e.target.id);
                      if (isUuid) {
                        setLoaderOpen(true);
                        dispatch(
                          deleteBookingFile(e.target.id, (res) => {
                            setLoaderOpen(false);
                            dispatch(
                              getValueByBookingTemplateId(
                                activity_assignment_id,
                                (resp) => {
                                  swal({
                                    content: (
                                      <CustomeModal
                                        type="success"
                                        title="Success!"
                                        content={`Uploaded file deleted successfully`}
                                      />
                                    ),
                                    buttons: false,
                                    closeOnClickOutside: false,
                                    closeOnEsc: false,
                                  });
                                }
                              )
                            );
                          })
                        );
                      } else {
                        setUploadedFile(
                          uploadedfile.filter(
                            (ele, index) => index !== parseInt(e.target.id)
                          )
                        );
                      }
                    }}
                  >
                    {ele.file_name === undefined ? ele.name : ele.file_name}
                    <span
                      id={
                        ele.booking_file_upload_id === undefined
                          ? index
                          : ele.booking_file_upload_id
                      }
                      className={`text-xs leading-3 font-semibold tracking-tight text-[#EB5757]`}
                    >
                      Remove
                    </span>
                  </div>
                );
              })}
            </div>
            <input
              id="updateBookingFile"
              type="file"
              onChange={(e) => {
                uploadFile(e.target.files);
              }}
              hidden
              multiple
            />
          </div>
        </div>
        {component.length !== 0 ? (
          <div className="flex justify-end space-x-2 my-2">
            <button
              className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
              onClick={(e) => {
                e.preventDefault();
                navigate("/booking/overview");
              }}
            >
              Cancel
            </button>
            <button
              className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
              type="submit"
            >
              Save and Next
            </button>
          </div>
        ) : null}
      </form>
      <Loader modalOpen={loaderOpen} />
    </div>
  );
}

export default UpdateBooking;
